var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7233 12.698C28.7767 13.7514 28.7767 15.4592 27.7233 16.5126C26.67 17.566 24.9621 17.566 23.9087 16.5126C22.8554 15.4592 22.8554 13.7514 23.9087 12.698C24.9621 11.6446 26.67 11.6446 27.7233 12.698",
    stroke: "url(#paint0_linear_1_265)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9368 7.88323C20.5588 9.5052 20.5588 12.1349 18.9368 13.7569C17.3148 15.3789 14.6851 15.3789 13.0631 13.7569C11.4411 12.135 11.4411 9.50522 13.0631 7.88323C14.6851 6.26125 17.3148 6.26125 18.9368 7.88323",
    stroke: "url(#paint1_linear_1_265)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09131 12.698C9.14469 13.7514 9.14469 15.4592 8.09131 16.5126C7.03794 17.566 5.33008 17.566 4.27671 16.5126C3.22334 15.4592 3.22334 13.7514 4.27671 12.698C5.33008 11.6446 7.03794 11.6446 8.09131 12.698",
    stroke: "url(#paint2_linear_1_265)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 25.3332V23.8719C30.6667 22.0306 29.1747 20.5386 27.3333 20.5386H26.2653",
    stroke: "url(#paint3_linear_1_265)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 25.3332V23.8719C1.33334 22.0306 2.82534 20.5386 4.66667 20.5386H5.73467",
    stroke: "url(#paint4_linear_1_265)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1187 25.3333V23.1987C23.1187 20.6213 21.0293 18.532 18.452 18.532H13.5467C10.9693 18.532 8.88 20.6213 8.88 23.1987V25.3333",
    stroke: "url(#paint5_linear_1_265)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_265",
    x1: 23.1187,
    y1: 14.6053,
    x2: 28.5134,
    y2: 14.6053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_265",
    x1: 11.8466,
    y1: 10.8201,
    x2: 20.1533,
    y2: 10.8201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_265",
    x1: 3.48668,
    y1: 14.6053,
    x2: 8.88134,
    y2: 14.6053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_265",
    x1: 26.2653,
    y1: 22.9359,
    x2: 30.6667,
    y2: 22.9359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_265",
    x1: 1.33334,
    y1: 22.9359,
    x2: 5.73467,
    y2: 22.9359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_265",
    x1: 8.88,
    y1: 21.9326,
    x2: 23.1187,
    y2: 21.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommunity);
export default __webpack_public_path__ + "static/media/icon-community.9fe08a9c0a6094c708ddbc817a293937.svg";
export { ForwardRef as ReactComponent };